import { combineReducers } from 'redux';
import chartPageReducer from './chartPageReducer';
import comRefs from './comRefs';
import routes from './routes';
import { ActionType } from '../action';
import { SET_CURR_IFRAME_URL } from '../action/constants';

export const rootReducer = combineReducers({
  chartPage: chartPageReducer,
  comRefs,
  routes,
  iframeUrl: (state: string = '', action: ActionType): string => {
    let res: string = state;
    if (action.type === SET_CURR_IFRAME_URL) {
      res = action.iframeUrl;
    }
    return res;
  },
});

export default rootReducer;

export type RootState = ReturnType<typeof rootReducer>;
